












import Vue from 'vue'
import { elementHandler } from '@/utils/helpers'

export default Vue.extend({
  name: 'AppNavbar',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFixed: false
    }
  },
  mounted() {
    if (!this.isFixed) {
      this.setHasNavbarFixedTop()
    }
  },
  destroyed() {
    if (this.isFixed) {
      this.clearHasNavbarFixedTop()
    }
  },
  methods: {
    setHasNavbarFixedTop() {
      elementHandler('html').then(html => {
        html.classList.add('has-navbar-fixed-top')
        this.isFixed = true
      })
    },

    clearHasNavbarFixedTop() {
      elementHandler('html').then(html => {
        html.classList.remove('has-navbar-fixed-top')
        this.isFixed = false
      })
    }
  }
})
